import { render, staticRenderFns } from "./StaffsSetting.vue?vue&type=template&id=0475c7f2&scoped=true&"
import script from "./StaffsSetting.vue?vue&type=script&lang=js&"
export * from "./StaffsSetting.vue?vue&type=script&lang=js&"
import style0 from "./StaffsSetting.vue?vue&type=style&index=0&id=0475c7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475c7f2",
  null
  
)

export default component.exports